import I18n from 'main/theme/i18n';

export function initI18n() {
    document.i18n = window.i18n = I18n.get;
}
